import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=3c6daa98&scoped=true&"
import script from "./Features.vue?vue&type=script&lang=ts&"
export * from "./Features.vue?vue&type=script&lang=ts&"
import style0 from "./Features.vue?vue&type=style&index=0&id=3c6daa98&lang=scss&scoped=true&"
import style1 from "./Features.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6daa98",
  null
  
)

export default component.exports